package com.anjuros.website.templates.template8.util

import com.anjuros.website.components.shared.CompanyDetailsType
import com.anjuros.website.components.shared.DetailsType
import com.anjuros.website.templates.template8.util.Template8Constants.CLIENTS_COMPANY
import com.anjuros.website.templates.template8.util.Template8Constants.CLIENTS_COMPANY_ADDRESS1
import com.anjuros.website.templates.template8.util.Template8Constants.CLIENTS_COMPANY_ADDRESS2
import com.anjuros.website.templates.template8.util.Template8Constants.CLIENTS_COMPANY_NUMBER
import com.anjuros.website.templates.template8.util.Template8Constants.CLIENTS_EMAIL
import com.anjuros.website.templates.template8.util.Template8Constants.CLIENTS_FB_NAME
import com.anjuros.website.templates.template8.util.Template8Constants.CLIENTS_NAME
import com.anjuros.website.templates.template8.util.Template8Constants.CLIENTS_PHONE

enum class Template8CompanyDetails: CompanyDetailsType {
    CLIENTS_EMAIL_INFO {
        override fun value(): String {
            return CLIENTS_EMAIL
        }

        override fun getType(): DetailsType {
            return DetailsType.EMAIL
        }
    },
    CLIENTS_COMPANY_INFO {
        override fun value(): String {
            return CLIENTS_COMPANY
        }

        override fun getType(): DetailsType {
            return DetailsType.COMPANY
        }
    },
    CLIENTS_NAME_INFO {
        override fun value(): String {
            return CLIENTS_NAME
        }

        override fun getType(): DetailsType {
            return DetailsType.COMPANY
        }
    },
    CLIENTS_FACEBOOK_INFO {
        override fun value(): String {
            return CLIENTS_FB_NAME
        }

        override fun getType(): DetailsType {
            return DetailsType.COMPANY_FACEBOOK
        }
    },
    CLIENTS_COMPANY_NUMBER_INFO {
        override fun value(): String {
            return CLIENTS_COMPANY_NUMBER
        }

        override fun getType(): DetailsType {
            return DetailsType.COMPANY_NUMBER
        }
    },
    CLIENTS_COMPANY_ADDRESS1_INFO {
        override fun value(): String {
            return CLIENTS_COMPANY_ADDRESS1
        }

        override fun getType(): DetailsType {
            return DetailsType.COMPANY_ADDRESS
        }
    },
    CLIENTS_COMPANY_ADDRESS2_INFO {
        override fun value(): String {
            return CLIENTS_COMPANY_ADDRESS2
        }

        override fun getType(): DetailsType {
            return DetailsType.COMPANY_ADDRESS
        }
    },
    CLIENTS_PHONE_INFO {
        override fun value(): String {
            return CLIENTS_PHONE
        }

        override fun getType(): DetailsType {
            return DetailsType.COMPANY_PHONE
        }
    },
}